import {
    Backdrop,
    Box,
    CircularProgress,
    Grid,
    Typography,
    Alert,
    AlertTitle,
} from '@mui/material';
import { grey } from '@mui/material/colors';
import { getSharedMemberCard } from 'api/memberServices';
import PageHeader from 'components/MemberConfirmation/PageHeader';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';

interface MemberCardMetadata {
    byteContent: string;
    fileName: string;
}

const MemberCardReview = () => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isLinkInvalid, setIsLinkInvalid] = useState<boolean>(false);
    const [memberCardMetadata, setMemberCardMetadata] = useState<
        MemberCardMetadata[] | null
    >(null);
    const { token } = useParams();

    useEffect(() => {
        setIsLoading(true);
        getSharedMemberCard(token as string)
            .then((response) => {
                setMemberCardMetadata(response);
            })
            .catch((error) => {
                setIsLinkInvalid(true);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [token]);

    return (
        <div>
            <PageHeader />
            {isLinkInvalid && (
                <Box
                    alignItems="center"
                    justifyContent="center"
                    minHeight="100vh"
                    display="flex"
                    flexDirection="column"
                    padding={5}
                >
                    <Alert severity="error">
                        <AlertTitle>Uh-oh!</AlertTitle>
                        The link is invalid or has expired. <br />
                        <br />
                        Once the link has been shared, it will be active for 30
                        minutes. Please verify the link or contact your agent
                        for a new one.
                    </Alert>
                </Box>
            )}
            {memberCardMetadata && (
                <Grid
                    container
                    alignItems="center"
                    justifyContent="center"
                    minHeight="100vh"
                    spacing={2}
                    sx={{
                        backgroundColor: grey[200],
                        padding: 2,
                        borderRadius: 1,
                    }}
                >
                    {memberCardMetadata?.map(
                        ({ byteContent, fileName }, index) => (
                            <Grid
                                item
                                lg={6}
                                key={index}
                                display="flex"
                                flexDirection="column"
                                alignItems="center"
                                justifyContent="center"
                            >
                                {byteContent ? (
                                    <>
                                        <Box
                                            component="img"
                                            sx={{
                                                width: '75%',
                                            }}
                                            alt={`${fileName} Member Card`}
                                            src={`data:image/png;base64,${byteContent}`}
                                        />
                                        <br />
                                        <a
                                            className="styled-like-a-button"
                                            download={fileName}
                                            href={`data:application/png;base64,${byteContent}`}
                                        >
                                            Download Image
                                        </a>
                                    </>
                                ) : (
                                    <Typography>No Image Preview</Typography>
                                )}
                            </Grid>
                        )
                    )}
                </Grid>
            )}
            <Backdrop
                sx={{
                    color: '#fff',
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
};
export default MemberCardReview;
